import { Moment } from 'moment';

export class DataModel {
  date: Moment;
}
